import { useEffect } from 'react';
import useUser from 'hooks/useUser';
import { getDashboardRedirectPath } from 'modules/auth/Auth.utils';
import pages from 'pages';
import { useNavigate, useParams } from 'react-router';
import { FlagKey } from '../../../../api/types';
import { useFeatureFlags } from '../../../../hooks/useFeatureFlags';

export function AutoPayRelay() {
  const { achAgreementId } = useParams();
  const navigate = useNavigate();
  const { userResult, selectedAgreement, setSelectedAgreement } = useUser();

  const {
    flags: { [FlagKey.onboardingRefresh]: onboardingRefresh },
  } = useFeatureFlags();

  useEffect(() => {
    if (achAgreementId && userResult?.user) {
      const { user } = userResult;
      const agreement = user.agreements.find(({ id }) => id === achAgreementId);
      const { hasDashboardAccess } = getDashboardRedirectPath(user, agreement, onboardingRefresh);
      if (agreement && !hasDashboardAccess) {
        // set selected agreement to the one requested in the url params if applicable
        if (selectedAgreement?.id !== agreement.id) setSelectedAgreement(agreement);

        const params = new URLSearchParams({ isAchRedirect: 'true' });
        navigate(`/${pages.STATUS}?${params.toString()}`);
      } else {
        // if the agreement wasn't in the current user's agreements or is already past M3, redirect to the user's dash
        navigate(`/${pages.DASHBOARD}`);
      }
    }
  }, [
    achAgreementId,
    navigate,
    setSelectedAgreement,
    selectedAgreement,
    userResult,
    onboardingRefresh,
  ]);

  return null;
}

export default AutoPayRelay;
